import { ChangeDetectionStrategy, Component, model } from '@angular/core';

@Component({
  selector: 'app-layout-container',
  templateUrl: './layout-container.component.html',
  styleUrls: ['./layout-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutContainerComponent {
  isFixed = model<boolean>(false);
  isFluid = model<boolean>(false);
}
